/** @format */

import { TProduct } from "../declarations/maps/products";
import { TStore } from "../declarations/store";

export const selectorProductList = (store: TStore): TProduct[] => store.products.productList || [];

export const selectorProduct = (store: TStore, id: string): TProduct | undefined =>
  store.products.productList?.find(product => product.id === id) || undefined;
